 
<template>
  
<v-bottom-navigation

 sticky
  v-model="selectedNav"
  style=" height:70px"
>


     <!--
        <v-btn to="/" class="nav-bottom-btn" value="recent" style="color:white; ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"/></svg>
          <span class="d-none d-md-inline">Home</span>
        </v-btn>
        <v-btn class="nav-bottom-btn"  value="recent" style="color:white">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ededed"><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Zm0-108q96-86 158-147.5t98-107q36-45.5 50-81t14-70.5q0-60-40-100t-100-40q-47 0-87 26.5T518-680h-76q-15-41-55-67.5T300-774q-60 0-100 40t-40 100q0 35 14 70.5t50 81q36 45.5 98 107T480-228Zm0-273Z"/></svg>
          <span class="d-none d-md-inline">Favorites</span>
        </v-btn>

   
        <v-btn class="nav-bottom-btn"  value="recent" style="color:white">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z"/></svg>
          <span class="d-none d-md-inline">New</span>
        </v-btn>
        <v-btn  to="/history" class="nav-bottom-btn"  value="recent" style="color:white">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M600-160q-134 0-227-93t-93-227q0-133 93-226.5T600-800q133 0 226.5 93.5T920-480q0 134-93.5 227T600-160Zm0-80q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70Zm91-91 57-57-108-108v-144h-80v177l131 132ZM80-600v-80h160v80H80ZM40-440v-80h200v80H40Zm40 160v-80h160v80H80Zm520-200Z"/></svg>
          <span class="d-none d-md-inline">Viewed</span>
        </v-btn>-->


        <v-btn to="/" class="nav-bottom-btn d-md-none" value="recent" style="  ">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-home-outline</v-icon>
               <span>Home</span>
        </v-btn>

        <v-btn to="/search" class="nav-bottom-btn d-md-none" value="recent" style="">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-magnify</v-icon>
          <span>Search</span>
        </v-btn>


        <v-btn to="/favorites" class="nav-bottom-btn d-md-none" value="recent" style=" ">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-bookmark-box-outline</v-icon>
          <span>Bookmarks</span>
        </v-btn>

        <v-btn to="/history" class="nav-bottom-btn d-md-none" value="recent" style=" ">
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-history</v-icon>
          <span>History</span>
        </v-btn>

        <v-btn  :onSignOut="onSignOut"  @click.prevent="showMenu = true" class="nav-bottom-btn d-md-none" value="recent" style=" ">

          
          <v-icon class="nav-bottom-btn-icon" size="31">mdi-dots-grid</v-icon>
          
          <span>Menu</span>

 
        </v-btn>

</v-bottom-navigation>
<Menu v-model="showMenu" :onSignOut="onSignOut" />
</template>













<script setup>
import { ref } from "vue"
import Menu from "../components/general/Menu.vue"







const showMenu = ref(false)









const drawer = ref(true)
const rail = ref(true)

defineProps({
  onSignOut: {
    type: Function,
    required: true
  },
  userName: { type: String, default: '' } 
})


</script>








<style scoped>
.nav-bottom-btn span{
  font-weight:300;
  font-size:9px;
}
.nav-bottom-btn {
  flex: 1 1 0;
  min-width: 0;      /* IMPORTANT */
  padding: 0;
}
.v-bottom-navigation {
  border-top: 1px solid rgba(255,255,255,0.08);
}
</style>




<style>
 

 

 
</style>

